module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c2VMR"))).then(() => parcelRequire('hEqeo'));